import React, { Component  } from 'react';
import PropTypes from 'prop-types';
import { MetricsElement } from "react-metrics";
import { addBet } from '../reducers/betlink';
import { trackClick } from 'utils/AnalyticsUtils';
import { isBetSlipEnabled } from 'utils/features';

import { connect } from 'react-redux';

export class PureBetLink extends Component {
  static propTypes = {
    marketId: PropTypes.string,
    eventId: PropTypes.string,
    eventName: PropTypes.string,
    eventCompetition: PropTypes.string,
    dateTime: PropTypes.string,
    fixture: PropTypes.string,
    sport: PropTypes.string,
    betId: PropTypes.string,
    betName: PropTypes.string,
    odds: PropTypes.string,
    isLive: PropTypes.bool,
    eachWay: PropTypes.object,
    suspended: PropTypes.bool,
    startingPriceAvailable: PropTypes.bool,
    forceLinkOut: PropTypes.bool,

    sendToBetslip: PropTypes.func.isRequired,
    className: PropTypes.string,
    children: PropTypes.node
  };

  constructor(props) {
    super(props);

    this.state = {
      betSlipEnabled: isBetSlipEnabled(true)
    }
  }

  componentDidMount() {
    const betSlipEnabled = isBetSlipEnabled(true);
    if (betSlipEnabled !== this.state.betSlipEnabled) {
      this.setState({
        betSlipEnabled
      });
    }
  }

  addBet() {
    const {
      marketId,
      eventId,
      eventName,
      eventCompetition, // only relevant for feature "integrated-betslip"
      dateTime,
      fixture, // only relevant for feature "integrated-betslip"
      sport,
      betId,
      betName,
      odds,
      isLive,
      eachWay, // only relevant for feature "integrated-betslip"
      suspended = false, // only relevant for feature "integrated-betslip"
      startingPriceAvailable // only relevant for feature "integrated-betslip"
    } = this.props;

    this.props.sendToBetslip({
      marketId,
      eventId,
      eventName,
      eventCompetition,
      dateTime,
      fixture,
      sport,
      betId,
      betName,
      odds,
      isLive,
      eachWay,
      suspended,
      startingPriceAvailable
    })
  }

  render() {
    const {
      marketId,
      eventId,
      betId,
      odds,

      className,
      children,
      forceLinkOut = false
    } = this.props;

    const addBetHandler = e => {
      e.preventDefault();

      this.addBet();
    }

    const buttonProps = {
      className,
      ...trackClick('addToBetSlip', {betlinkId: eventId})
    };

    if (marketId && eventId && betId && this.state.betSlipEnabled && !forceLinkOut) {
      Object.assign(buttonProps, {
        href: "#",
        onClick: addBetHandler
      });
    }
    else {
      Object.assign(buttonProps, {
        href: `http://m.skybet.com/go/event/${eventId}/bet?sels=${betId}|${odds}&aff=681&dcmp=sl_hr_betlink`,
        target: "_blank"
      });
    }

    if (betId) {
      return (<MetricsElement>
        <a {...buttonProps}>{children}</a>
      </MetricsElement>);
    }
    else {
      return <span {...buttonProps}>{children}</span>;
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
      sendToBetslip: (data) => {
          dispatch(addBet(data))
      }
  }
}

export default connect(null, mapDispatchToProps)(PureBetLink);


// WEBPACK FOOTER //
// ./modules/Common/containers/BetLink.js